import { useContext } from 'react';

import { SearchModeContext } from './SearchModeContext';
import type { ChatInputInternalProps } from './types';

export const useSearchMode = (): ChatInputInternalProps['searchMode'] =>
	useContext(SearchModeContext);
